export default function PublicEndpointsGuide() {
  return (
    <div>
      <h1>Unauthenticated public endpoints</h1>
      <p>
        A small set of endpoints are <strong>public</strong> — they require no
        authentication. These power candidate-facing experiences and are not
        part of the API-key surface. They're listed here for completeness;
        most integrators won't need them.
      </p>

      <h2>Careers page</h2>
      <p>
        Customers' careers pages are powered by these endpoints. Use them to
        embed open jobs on a marketing site or build a custom apply flow.
      </p>
      <ul>
        <li>
          <code>GET /api/v1/public/careers</code> — list public jobs for an org.
        </li>
        <li>
          <code>GET /api/v1/public/careers/{'{'}job_id{'}'}</code> — get a public
          job.
        </li>
        <li>
          <code>GET /api/v1/public/careers/{'{'}job_id{'}'}/questions</code> —
          custom application questions.
        </li>
        <li>
          <code>POST /api/v1/public/careers/{'{'}job_id{'}'}/apply</code> —
          submit an application.
        </li>
      </ul>

      <h2>Candidate scheduling links</h2>
      <p>
        Candidates pick interview times via tokenized scheduling links. The
        token itself is the auth.
      </p>
      <ul>
        <li>
          <code>GET /api/v1/public/scheduling/{'{'}token{'}'}</code>
        </li>
        <li>
          <code>GET /api/v1/public/scheduling/{'{'}token{'}'}/busy-times</code>
        </li>
        <li>
          <code>POST /api/v1/public/scheduling/{'{'}token{'}'}/availability</code>
        </li>
        <li>
          <code>POST /api/v1/public/scheduling/{'{'}token{'}'}/cancel-meeting</code>
        </li>
      </ul>

      <h2>Why aren't these in the API reference?</h2>
      <p>
        The API reference page lists endpoints you call with an API key. The
        public endpoints above are called from end-users' browsers (careers
        page, scheduling link) and don't accept{' '}
        <code>Authorization: Bearer cho_*</code>.
      </p>
      <p>
        <em>Asking a careers page to authenticate would be cruel.</em>
      </p>
    </div>
  )
}
